const platform = {
    title: '平台設定',
    subtitle: '管理跨租戶的平台管理員和全域平台外觀。',
    branding_title: '平台品牌',
    branding_description: '統一套用至控制台、登入註冊、帳戶中心、示範應用程式和說明中心。',
    product_name: '產品名稱',
    slogan: '品牌標語',
    light_logo: '淺色主題標誌',
    dark_logo: '深色主題標誌',
    upload_logo: '上傳標誌',
    uploading: '正在上傳…',
    logo_uploaded: '標誌已上傳',
    hide_open_source_notice: '隱藏開源聲明',
    hide_open_source_notice_description: '隱藏介面中的歸屬連結，同時保留授權和原始碼聲明檔案。',
    save: '儲存變更',
    saving: '正在儲存…',
    saved: '平台品牌已儲存',
    administrators_title: '平台管理員',
    administrators_description: '平台管理員可以管理所有租戶和執行個體層級設定。',
    administrator_identifier_placeholder: '使用者 ID、使用者名稱或電子郵件',
    add_administrator: '新增管理員',
    administrator_added: '平台管理員已新增',
    remove_administrator: '移除平台管理員',
};
export default Object.freeze(platform);
